import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/index.css";
import Seo from "@/components/Seo";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import HeartOfWork from "@/components/HeartOfWork";
import Collective from "@/components/Collective";
import TonalIntentions from "@/components/TonalIntentions";
import Founder from "@/components/Founder";
import Resonance from "@/components/Resonance";
import Evolving from "@/components/Evolving";
import FinalCta from "@/components/FinalCta";
import SoulInLovePage from "@/pages/SoulInLove";
import AmberEllisPage from "@/pages/AmberEllis";
import TundalaPage from "@/pages/Tundala";

const Landing = () => (
  <main>
    <Seo
      title="The SEAL Collective | Voice, Consciousness, Creativity & Human Transformation"
      description="The SEAL Collective brings together voice, sound, consciousness, creativity, technology, leadership, and human-centered transformation through the work of Amber Ellis."
      path="/"
    />
    <Hero />
    <Marquee />
    <HeartOfWork />
    <Collective />
    <TonalIntentions />
    <Founder />
    <Resonance />
    <Evolving />
    <FinalCta />
  </main>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

const Shell = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-[#faf8f4] text-[#16130e]">
      <ScrollToTop />
      <Nav />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/soul-in-love" element={<SoulInLovePage />} />
        <Route path="/amber-ellis" element={<AmberEllisPage />} />
        <Route path="/tundala" element={<TundalaPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="bottom-center" />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}

export default App;
